<template>
  <app-page-container class="automation-workspace" :custom="1600" :min-height="0" tabindex="-1">
    <router-view :key="$route.params.run_id || 'list'" />
  </app-page-container>
</template>
<script>
import './workspace.scss'

export default { name: 'FollowUpAutomationWorkspace' }
</script>
